/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class SearchApi extends runtime.BaseAPI {
    /**
     * Search Stations
     */
    async v2SearchStationsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }
        if (requestParameters['forceRefresh'] != null) {
            queryParameters['force_refresh'] = requestParameters['forceRefresh'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/search/stations`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Search Stations
     */
    async v2SearchStations(requestParameters = {}, initOverrides) {
        const response = await this.v2SearchStationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
